(function () {
  function initSlider(wrapper) {
    if (wrapper._bdrInit) return;
    wrapper._bdrInit = true;

    var track   = wrapper.querySelector('.bdr-amati__track');
    var items   = Array.from(wrapper.querySelectorAll('.bdr-amati__item'));
    var prevBtn = wrapper.querySelector('.bdr-amati__prev');
    var nextBtn = wrapper.querySelector('.bdr-amati__next');

    if (!track || items.length < 2) return;

    var current = 0;

    function getVisible() {
      if (window.innerWidth >= 990) return 4;
      if (window.innerWidth >= 750) return 3;
      return 1;
    }

    function getMax() {
      return Math.max(0, items.length - getVisible());
    }

    function computeShift(n) {
      var max = getMax();
      if (n < max) return n * items[0].offsetWidth;
      var viewportEl  = track.parentElement;
      var stile       = getComputedStyle(viewportEl);
      var totalTrack  = items.reduce(function (s, i) { return s + i.offsetWidth; }, 0);
      if (stile.overflow === 'hidden') {
        return Math.max(0, totalTrack - viewportEl.clientWidth);
      }
      var paddingLeft = parseFloat(stile.paddingLeft) || 0;
      return Math.max(0, totalTrack + paddingLeft - wrapper.offsetWidth);
    }

    function goTo(n) {
      var max = getMax();
      if (max === 0) return;
      if (n < 0) n = max;
      if (n > max) n = 0;
      current = n;
      track.style.transform = 'translateX(-' + computeShift(current) + 'px)';
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    var touchStartX = 0;
    wrapper.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    wrapper.addEventListener('touchend', function (e) {
      var delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) < 50) return;
      goTo(delta < 0 ? current + 1 : current - 1);
    }, { passive: true });

    window.addEventListener('resize', function () { goTo(Math.min(current, getMax())); });

    goTo(0);
  }

  function agganciaCarosello(productRecs) {
    var wrapper = productRecs.querySelector('[data-related-slider]');
    if (wrapper) initSlider(wrapper);
  }

  document.querySelectorAll('product-recommendations').forEach(function (el) {
    agganciaCarosello(el);

    // Dopo il fetch dei suggeriti, Dawn riscrive l'intero contenuto della
    // sezione: il wrapper agganciato qui sopra sparisce e con lui i pulsanti.
    // L'osservatore resta in ascolto per rimontare il carosello sul markup
    // nuovo. Il segnale di avvenuto montaggio sta sul nodo, quindi un wrapper
    // già attivo non viene inizializzato due volte.
    new MutationObserver(function () {
      agganciaCarosello(el);
    }).observe(el, { childList: true, subtree: true });
  });
})();
